import { Box } from '@chakra-ui/react'


const BoxWrapper = ({ children }) => {
    return (
        <Box p={4} border={"1px solid #0000001a"} m={8} bg={"white"} borderRadius={"15px"}>
            <Box bg={"white"} p={2}>
                {children}
            </Box>
        </Box>
    )
}

export default BoxWrapper